import * as Yup from 'yup';
import type { IncidentReportYesNoOther } from 'components/CriticalIncident/interfaces';
import { yesNoOther, requiredWhenIs } from '../utils';

export const initialValues = {
    wereAnyRecommendationsDiscussed: '' as IncidentReportYesNoOther,
    wereAnyRecommendationsDiscussedOtherReason: '',
    summaryOfRecommendations: '',
    anyServicesRecommended: '',
};

export const validationSchema = Yup.object({
    wereAnyRecommendationsDiscussed: yesNoOther.required('error_required_field'),
    wereAnyRecommendationsDiscussedOtherReason: Yup.string().when('wereAnyRecommendationsDiscussed', requiredWhenIs('O')),
    summaryOfRecommendations: Yup.string().notRequired(),
    anyServicesRecommended: Yup.string().notRequired(),
});
